export default "/_next/static/images/a719207422d45b93b7729b30645cdf72.jpg";